<template>
	<div
		:class="{'prev-next': true, 'prev-next--with-submit': $route.meta.submittable}"
		v-if="$route.name !== 'model'"
	>
		<router-link
			v-if="$route.meta.prev"
			class="prev-next__prev"
			:to="{name: $route.meta.prev}"
			@click.native="scrollToTop"
		>
			<div class="prev-next__prev-wrapper">
				<BackArrow />
				<span class="uppercased-text prev-next__prev-text">Wróć</span>
			</div>
		</router-link>
		<router-link
			v-if="$route.meta.next"
			class="button prev-next__next"
			:to="{name: $route.meta.next}"
			@click.native="scrollToTop"
		>
			Dalej
		</router-link>

		<SubmitConfiguration v-if="$route.meta.submittable && !user" />
		<h4 v-if="$route.meta.submittable && user">
			Wygeneruj ofertę przyciskiem po prawej stronie ekranu
		</h4>
	</div>
</template>

<script>
import BackArrow from './BackArrow';
import SubmitConfiguration from './SubmitConfiguration';

export default {
	name: 'PrevNextNavigation',
	components: {BackArrow, SubmitConfiguration},
	computed: {
		user() {
			return this.$store.state.user;
		},
	},
	methods: {
		scrollToTop() {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		},
	},
};
</script>
